import React, { forwardRef, useImperativeHandle } from "react";
import { Grid, TextField } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { Controller, useForm } from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import { selectUser } from "../../features/data/user/userSlice";

const ValuationFiltersForm = forwardRef((props, ref) => {
  const { onSubmitForm, defaultValues, mode = "new", loading = false } = props;

  const { control, handleSubmit, reset } = useForm({
    defaultValues: defaultValues ?? {
      from_date: null,
      to_date: null,
      id: "",
      full_id: "",
      first_name: "",
      last_name: "",
      user_first_name: "",
      user_last_name: "",
      user_work_title: "",
      phone_number: "",
      city: "",
      postal_code: "",
      address: "",
    },
  });
  const { user } = useSelector(selectUser, shallowEqual);

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitForm)(),
    reset: () => reset(),
  }));

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} lg={3}>
          <Controller
            name="id"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="شناسه"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name="full_id"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="شناسه کل"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name="first_name"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="نام"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <Controller
            name="last_name"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="نام خانوادگی"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        {(user.role === "user" || user.role === "admin") && (
          <>
            <Grid item xs={12} lg={3}>
              <Controller
                name="user_first_name"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="نام ارزیاب"
                    size="small"
                    margin="dense"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <Controller
                name="user_last_name"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="نام خانوادگی ارزیاب"
                    size="small"
                    margin="dense"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <Controller
                name="user_work_title"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="نام دفتر کارشناسی"
                    size="small"
                    margin="dense"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
          </>
        )}

        <Grid item xs={12} lg={3}>
          <Controller
            name="phone_number"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="تلفن همراه مشتری"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name="from_date"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                variant="dialog"
                inputVariant="outlined"
                margin="dense"
                showTodayButton
                fullWidth
                date
                label="از تاریخ"
                okLabel="تأیید"
                todayLabel="امروز"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name="to_date"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                variant="dialog"
                inputVariant="outlined"
                margin="dense"
                showTodayButton
                fullWidth
                date
                label="تا تاریخ"
                okLabel="تأیید"
                todayLabel="امروز"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name="city"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="شهر"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name="postal_code"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="کد پستی"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <Controller
            name="address"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="آدرس"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
    </form>
  );
});

export default ValuationFiltersForm;
